import { getTags } from './getTags';
import { toastError, toastSuccess } from '../../utils/toastMessage';
import API from '../../utils/API';

export const editingTag = (editingTagObj) => {
  return {
    type: 'CONFIRM_EDITING_TAG',
    payload: {
      editingTagObj,
    },
  };
};

export const cancelEditingTag = () => {
  return {
    type: 'CANCEL_EDITING_TAG',
  };
};

export const creatingTag = () => {
  return {
    type: 'CONFIRM_CREATING_TAG',
  };
};

export const tagEditSuccess = () => {
  return {
    type: 'TAG_EDIT_SUCCESS',
  };
};

export const editTag = (tagId, name) => {
  return (dispatch) => {
    API.put('/tags', {
      tagId,
      name,
    })
      .then(() => {
        toastSuccess();
        dispatch(tagEditSuccess());
        dispatch(getTags());
      })
      .catch(() => {
        toastError();
      });
  };
};

export const createTag = (name, category_id) => {
  return (dispatch) => {
    API.post('/tags', {
      name,
      category_id,
    })
      .then(() => {
        toastSuccess();
        dispatch(tagEditSuccess());
        dispatch(getTags());
      })
      .catch(() => {
        toastError();
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/tags/tagEdit.js